import { http } from '@/api/http';

import { authUserSchema, loginResponseSchema, type AuthUser, type LoginResponse } from './types';

interface LoginPayload {
  email: string;
  password: string;
  remember?: boolean;
  /** Sent so the API can label the token in the user's session list. */
  device_name: string;
}

export const authApi = {
  async login(payload: LoginPayload): Promise<LoginResponse> {
    const data = await http.post<unknown>('/admin/login', {
      ...payload,
      remember: payload.remember ?? false,
    });
    return loginResponseSchema.parse(data);
  },

  async me(signal?: AbortSignal): Promise<AuthUser> {
    const data = await http.get<unknown>('/admin/me', signal ? { signal } : {});
    return authUserSchema.parse(data);
  },

  async logout(): Promise<void> {
    await http.post<null>('/admin/logout');
  },

  async requestPasswordReset(email: string): Promise<void> {
    await http.post<null>('/admin/password/forgot', { email });
  },

  async resetPassword(payload: {
    token: string;
    email: string;
    password: string;
    password_confirmation: string;
  }): Promise<void> {
    await http.post<null>('/admin/password/reset', payload);
  },
};

/** Identifies this browser in the API's token list. */
export function currentDeviceName(): string {
  const agent = window.navigator.userAgent;
  return agent.length > 120 ? `${agent.slice(0, 117)}...` : agent;
}
